<template>
  <div
    class="page max-w-[1010px]"
    data-test="page"
  >
    <div
      class="header text-center md:text-left mx-8 sm:mx-0 mt-5 lg:mt-0 flex flex-row items-center justify-between"
      data-test="header"
    >
      Company Giving Overview
      <div
        class="flex flex-row gap-4"
        data-test="buttons"
      >
        <Button
          @click="router.push('/company/public-page')"
          size="small"
          variant="outlined"
          data-test="edit-profile-button"
        >
          <Pencil
            class="w-[14px] h-[14px]"
            :fill="donorStore.mainColor"
          />
          <span>Edit Profile</span>
        </Button>
        <Button
          size="small"
          variant="outlined"
          @click="viewPage(donorStore.domain, companyAdminStore.company.customUrl)"
          data-test="view-page-button"
        >
          <Eye
            class="w-[15px] h-[15px]"
            :fill="donorStore.mainColor"
          />
          <span>View Page</span>
        </Button>
      </div>
    </div>
    <template v-if="donorStore.isDataLoaded">
      <div
        class="mx-4 lg:ml-0"
        data-test="content"
      >
        <WelcomeCard
          class="mb-10"
          data-test="welcome-card"
        />
        <div
          class="middle xl:grid xl:grid-cols-[2fr_3fr] xl:gap-x-12"
          data-test="middle-section"
        >
          <StatsCard
            class="flex xl:order-2"
            data-test="stats-card"
          ></StatsCard>
          <RecentDonations
            class="flex mt-8 xl:mt-0 xl:order-1"
            data-test="recent-donations"
          />
        </div>
        <div
          class="flex flex-col justify-center xl:mt-8 mb-8"
          data-test="resource-section"
        >
          <ResourceCard
            class="mt-8 xl:mt-0"
            data-test="resource-card"
          />
        </div>
      </div>
    </template>
    <WelcomeMessageHolder data-test="welcome-message-holder" />
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import WelcomeCard from '@/components/companyGiving/WelcomeCard.vue';
import RecentDonations from '@/components/companyGiving/RecentDonations.vue';
import StatsCard from '@/components/companyGiving/StatsCard.vue';
import ResourceCard from '@/components/companyGiving/ResourceCard.vue';
import { useRouter } from 'vue-router';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import WelcomeMessageHolder from '@/pages/donorAccount/welcomeMessage/WelcomeMessageHolder.vue';
import Pencil from '@/assets/Pencil.vue';
import Eye from '@/assets/Eye.vue';
import viewPage from '@/helpers/viewPage';

const donorStore = useDonorStore();
const companyAdminStore = useCompanyAdminStore();
const router = useRouter();

// onBeforeMount hook to run check on component mount
onBeforeMount(async () => {
  companyAdminStore.getRecentDonations();
  companyAdminStore.getTopCauses();
  companyAdminStore.getStatistics();
  companyAdminStore.getResources();
});
</script>
